import React from 'react';

export default function PoliticalInfo() {
  return (
    <section id="political-info">
      <p className="body-title mt-4">Painel de informações</p>
    </section>
  );
}
